import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=626358f8&"
import script from "./Coupons.vue?vue&type=script&lang=ts&"
export * from "./Coupons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports